/**
 * Editor de la **tabla simple** de la Sección 3 (`precios_tubo_remarco`, "Tubos
 * 7×8"): una lista plana de pares `[hasta, precio]` SIN dimensión de calibre.
 *
 * Columnas `Hasta (cm) | Precio`; como el SSR, **no** se añaden/quitan filas: solo
 * se editan las celdas existentes. El orden por `hasta` se aplica al construir el
 * body. Presentacional: el estado lo posee `PreciosForm`.
 */
import {
  Input,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@/components/ui";

import type { TablaRow } from "../precios.transform";

interface TablaSimpleEditorProps {
  title: string;
  rows: TablaRow[];
  onChange: (rows: TablaRow[]) => void;
}

export function TablaSimpleEditor({ title, rows, onChange }: TablaSimpleEditorProps) {
  function setCell(index: number, field: keyof TablaRow, value: string) {
    onChange(rows.map((row, i) => (i === index ? { ...row, [field]: value } : row)));
  }

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>Hasta (cm)</TableHeaderCell>
            <TableHeaderCell>Precio</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={2} className="text-center text-slate-500">
                Sin datos.
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Input
                    type="number"
                    step="0.1"
                    inputMode="decimal"
                    aria-label={`${title} fila ${index + 1} hasta`}
                    value={row.hasta}
                    onChange={(event) => setCell(index, "hasta", event.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <Input
                    type="number"
                    step="0.01"
                    inputMode="decimal"
                    aria-label={`${title} fila ${index + 1} precio`}
                    value={row.precio}
                    onChange={(event) => setCell(index, "precio", event.target.value)}
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
